import { useContext } from 'react';
import SectionContentGroupContext from '../../../SectionContentGroupContext';
import useSelectableFieldTypesForSectionContentGroups from './useSelectableFieldTypesForSectionContentGroups';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import FieldType from '@/lib/constants/challengeModel/FieldType.enum';
import SelectedModelIdContext from '../../../../../SelectedModelIdContext';
import ModelsContext from '@/pages/EditorPage/ChallengeModelsEditor/ModelsContext';

const useSelectableFieldTypes = (): FieldType[] => {
  const currentSectionContentGroup = useContext(SectionContentGroupContext);
  const selectableFieldTypesForCurrentSectionContentGroup =
    useSelectableFieldTypesForSectionContentGroups()[
      currentSectionContentGroup
    ];

  const [models] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const selectedModelType = models[selectedModelId].type;

  const unavailableFieldTypesForCurrentModelType =
    selectedModelType === ModelType.CHALLENGE
      ? [FieldType.MANUAL_ASSIGNEES]
      : [FieldType.MANUAL_CHALLENGE_SHARING];

  return selectableFieldTypesForCurrentSectionContentGroup.filter(
    fieldType => !unavailableFieldTypesForCurrentModelType.includes(fieldType),
  );
};

export default useSelectableFieldTypes;
